// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let DragDrop = require("../../../reason/settings/components/dragDrop/DragDrop.bs.js");
let Belt_Array = require("@rescript/runtime/lib/js/Belt_Array.js");
let Attachments = require("../../../reason/common/Attachments/Attachments.bs.js");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let ContentBox__Jsx3 = require("../../../uikit/reason/atoms/ContentBox/ContentBox__Jsx3.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let InitialUploadPrompt = require("../../../reason/settings/components/avatarField/InitialUploadPrompt.bs.js");
let AttachmentFormSection = require("../../common/attachments/AttachmentFormSection.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let PropertyWizardRelayPhotosAndFiles_draft_graphql = require("../../../__generated__/PropertyWizardRelayPhotosAndFiles_draft_graphql.bs.js");

let convertFragment = PropertyWizardRelayPhotosAndFiles_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPhotosAndFiles_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPhotosAndFiles_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPhotosAndFiles_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPhotosAndFiles_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function add(addImages, addFiles, files) {
  let match = Belt_Array.partition(files, file => Attachments.Attachment.ContentType.isImage(file.type));
  let files$1 = match[1];
  let images = match[0];
  if (images.length !== 0) {
    addImages(images);
  }
  if (files$1.length !== 0) {
    return addFiles(files$1);
  }
}

function PropertyWizardRelay__PhotosAndFiles(props) {
  let match = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPhotosAndFiles_draft_graphql.node, convertFragment, props.draft);
  let draftProperty = match.draftProperty;
  let setFormState = PropertyWizardFormRelay.FormState.useUpdater();
  let imagesProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (dp, value) => {
      let newrecord = {...dp};
      newrecord.images = Stdlib_Option.getOr(value, []).map(param => {
        let attachment = param[1];
        return {
          contentType: attachment.contentType,
          fileName: attachment.fileName,
          id: attachment.id,
          key: attachment.key,
          previewUrl: param[0]
        };
      });
      return newrecord;
    }
  }, true, draftProperty.images.map(image => [
    image.previewUrl,
    {
      id: image.id,
      key: image.key,
      fileName: image.fileName,
      contentType: image.contentType
    }
  ]), "Valid");
  let filesProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (dp, value) => {
      let newrecord = {...dp};
      newrecord.files = Stdlib_Option.getOr(value, []).map(attachment => ({
        contentType: attachment.contentType,
        fileName: attachment.fileName,
        id: attachment.id,
        key: attachment.key
      }));
      return newrecord;
    }
  }, true, draftProperty.files.map(file => ({
    id: file.id,
    key: file.key,
    fileName: file.fileName,
    contentType: file.contentType
  })), "Valid");
  let onUnsupportedFileError = Attachments.useUnsupportedFilesSystemMessage();
  let match$1 = React.useState(() => draftProperty.images.map(image => ({
    previewUrl: image.previewUrl,
    state: {
      TAG: "Success",
      _0: {
        id: image.id,
        key: image.key,
        fileName: image.fileName,
        contentType: image.contentType
      }
    }
  })));
  let setImgs = match$1[1];
  let match$2 = React.useState(() => draftProperty.files.map(file => ({
    previewUrl: undefined,
    state: {
      TAG: "Success",
      _0: {
        id: file.id,
        key: file.key,
        fileName: file.fileName,
        contentType: file.contentType
      }
    }
  })));
  let setFiles = match$2[1];
  let updateImages = images => {
    let images$1 = Stdlib_List.toArray(images);
    let imagesReadyToSave = Stdlib_Array.filterMap(images$1, image => {
      let attachment = image.state;
      if (attachment.TAG === "Success") {
        return [
          image.previewUrl,
          attachment._0
        ];
      }
    });
    imagesProps.onChange(imagesReadyToSave);
    setImgs(param => images$1);
    setFormState(formState => {
      formState.imagesStatus = Stdlib_Array.filterMap(images$1, image => {
        let match = image.state;
        switch (match.TAG) {
          case "InProgress" :
            return "InProgress";
          case "Failed" :
            return "Failed";
          case "NotStarted" :
          case "Success" :
            return;
        }
      });
    });
  };
  let updateFiles = files => {
    let files$1 = Stdlib_List.toArray(files);
    let filesReadyToSave = Stdlib_Array.filterMap(files$1, image => {
      let attachment = image.state;
      if (attachment.TAG === "Success") {
        return attachment._0;
      }
    });
    filesProps.onChange(filesReadyToSave);
    setFiles(param => files$1);
    setFormState(formState => {
      formState.filesStatus = Stdlib_Array.filterMap(files$1, file => {
        let match = file.state;
        switch (match.TAG) {
          case "InProgress" :
            return "InProgress";
          case "Failed" :
            return "Failed";
          case "NotStarted" :
          case "Success" :
            return;
        }
      });
    });
  };
  let images = Attachments.useAttachments(updateImages, Stdlib_List.fromArray(match$1[0]), onUnsupportedFileError);
  let files = Attachments.useAttachments(updateFiles, Stdlib_List.fromArray(match$2[0]), onUnsupportedFileError);
  let add$1 = extra => add(images.add, files.add, extra);
  let match$3 = images.attachments.concat(files.attachments);
  return JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
    children: JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
      width: 12,
      widthLg: 9,
      children: JsxRuntime.jsx(ContentBox__Jsx3.make, {
        children: JsxRuntime.jsx(DragDrop.DragDropContext.make, {
          children: JsxRuntime.jsx(DragDrop.DropArea.make, {
            onChange: add$1,
            children: match$3.length !== 0 ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  JsxRuntime.jsx(AttachmentFormSection.ImageUploadList.make, {
                    onAddAttachments: add$1,
                    onDeleteAttachment: images.delete,
                    reorder: images.reorder,
                    uploads: images.attachments
                  }),
                  JsxRuntime.jsx(AttachmentFormSection.FileUploadList.make, {
                    onAddAttachments: add$1,
                    onDeleteAttachment: files.delete,
                    reorder: files.reorder,
                    uploads: files.attachments
                  })
                ]
              }) : JsxRuntime.jsx(InitialUploadPrompt.make, {
                onAddAttachments: add$1
              })
          })
        })
      })
    })
  });
}

let FormUtils;

let Form;

let Cell;

let Grid;

let ContentBox;

let DraftAttachment;

let make = PropertyWizardRelay__PhotosAndFiles;

exports.FormUtils = FormUtils;
exports.Form = Form;
exports.Cell = Cell;
exports.Grid = Grid;
exports.ContentBox = ContentBox;
exports.DraftAttachment = DraftAttachment;
exports.DraftFragment = DraftFragment;
exports.add = add;
exports.make = make;
/* react Not a pure module */
